export const getRecaptchaKey = () => {
  console.log("Recaptcha Key:", import.meta.env.VITE_RECAPTCHA_KEY);

  return import.meta.env.VITE_RECAPTCHA_KEY || "key_here";
};
